"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var createIcon_1 = __importDefault(require("../createIcon"));
var BrandIconHealth = function (props) {
    return (react_1.default.createElement(createIcon_1.default, __assign({ role: "img", ariaLabel: "Health" }, props),
        react_1.default.createElement("title", null, "Health"),
        react_1.default.createElement("path", { d: "M59.995 106.888l42.61-42.61-42.61-42.611v85.221z", fill: "#D44513" }),
        react_1.default.createElement("path", { d: "M59.995 106.888l-42.611-42.61 42.61-42.611v85.221z", fill: "#007562" }),
        react_1.default.createElement("path", { d: "M59.995 21.688c11.764-11.764 30.835-11.764 42.6 0 11.764 11.765 11.764 30.836 0 42.6", fill: "#FF6E00" }),
        react_1.default.createElement("path", { d: "M17.395 64.288c-11.765-11.764-11.765-30.835 0-42.6 11.764-11.775 30.835-11.775 42.6 0", fill: "#000" })));
};
exports.default = BrandIconHealth;
